import React, { useEffect, useState } from "react";
import {
    WorkTimeFormOptionsMapping,
    useWorkTimeFormOptions,
} from "../../hooks/worktime/useWorkTimeFormOptions";
import { IWorkTimeSaveData } from "../../models/workShiftTimeSlot/workTimeSaveData";
import { Base } from "../../framework/common/base";
import { useParams } from "react-router-dom";
import { fetchWorkShiftTimeSlot } from "../../framework/redux/slices/workShiftTimeSlotSlice";
import { useAsyncThunkAction } from "../../hooks/framework/useAsyncThunkAction";
import { handleApiError } from "../../services/baseService";
import { useSelectWorkShiftTimeSlotById } from "../../hooks/worktime/useSelectWorkShiftTimeSlots";
import { WorkTimeForm } from "./workTimeForm";
import { LoadingIndicator } from "../framework/loadingIndicator";
import { HourBookingCategory } from "../../models/workHours/workHoursItem";
import { useWorkTimeDefaultTimezone } from "../../hooks/framework/useWorkTimeDefaultTimezone";

interface Props {
    isCustom?: boolean;
}

export const WorkTimeFormMain = ({ isCustom = false }: Props) => {
    const [formOptions, ready] = useWorkTimeFormOptions(
        Object.keys(WorkTimeFormOptionsMapping),
        isCustom
            ? [HourBookingCategory.CustomAnyType]
            : [
                HourBookingCategory.CustomNormalType,
                HourBookingCategory.CustomAddition,
            ]
    );
    const [workShiftTimeSlotItem, setWorkShiftTimeSlotItem] =
        useState<IWorkTimeSaveData>();
    const { date } = useParams();
    const { id: selectedWorkTimeId } = useParams();
    const workShiftTimeSlot =
        useSelectWorkShiftTimeSlotById(selectedWorkTimeId);
    const [defaultTz, loadingTz] = useWorkTimeDefaultTimezone();

    useAsyncThunkAction(
        () => {
            if (selectedWorkTimeId)
                return fetchWorkShiftTimeSlot({ id: selectedWorkTimeId });
        },
        { onError: handleApiError },
        [selectedWorkTimeId]
    );

    useEffect(() => {
        if (!workShiftTimeSlotItem && !selectedWorkTimeId && !loadingTz) {
            const jsonDate = Base.dateToDateJSON(date);
            const startTimeObject = new Date(jsonDate);
            startTimeObject.setHours(8, 0, 0);
            const endTimeObject = new Date(jsonDate);
            endTimeObject.setHours(16, 0, 0);
            setWorkShiftTimeSlotItem({
                costCenterId: "",
                workTimeTypeId: "",
                vehicleId: "",
                startDate: Base.dateToDateTimeStrWithTimezone(startTimeObject),
                endDate: Base.dateToDateTimeStrWithTimezone(endTimeObject),
                comment: "",
                salaryRowTypeId: "",
                id: "",
                rowId: "",
                timeZoneName: defaultTz,
                isCustomType: isCustom,
                customerId: "",
            });
        }
    }, [selectedWorkTimeId, workShiftTimeSlotItem, defaultTz, loadingTz]);

    useEffect(() => {
        if (
            workShiftTimeSlot?.id &&
            workShiftTimeSlot?.id === selectedWorkTimeId
        ) {
            const {
                costCenterId,
                workTimeTypeId,
                vehicleId,
                startDate,
                endDate,
                comment,
                salaryRowTypeId,
                id,
                rowId,
                timeZoneName,
                isCustomType,
                customerId,
            } = workShiftTimeSlot;

            setWorkShiftTimeSlotItem({
                costCenterId,
                workTimeTypeId,
                vehicleId,
                startDate:
                    Base.dateStrToOriginalTimezoneJsonDateTime(startDate),
                endDate: Base.dateStrToOriginalTimezoneJsonDateTime(endDate),
                comment,
                salaryRowTypeId,
                id,
                rowId,
                timeZoneName,
                isCustomType,
                customerId,
            });
        }
    }, [workShiftTimeSlot, selectedWorkTimeId]);

    return ready &&
        workShiftTimeSlotItem &&
        (workShiftTimeSlotItem?.id === selectedWorkTimeId ||
            !selectedWorkTimeId) ? (
                <WorkTimeForm
                    workShiftTimeSlotItem={workShiftTimeSlotItem}
                    formOptions={formOptions}
                />
        ) : (
            <LoadingIndicator />
        );
};
